import { ToggleComponent } from '../../../../shared/featureToggle';
import EntityBusinessLayerList from './EntityBusinessLayerList';
import ManagerViewLocations from './ManagerViewOnePage/ManagerViewLocations';

export default ToggleComponent(ManagerViewLocations, {
  StyledComponentsVariants: {
    'circle-k': EntityBusinessLayerList,
  },
});
